import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitleOptions, DialogContentOptions, ConfirmationTextOptions, CancellTextOptions} from './leave-confirm-dialog-options';

type IProps = {
  handleLeave: () => void;
  handleClose: () => void;
  open: boolean;
  // setOpen: () => void;
};

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose?: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[600],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export default function LeaveConfirmDialog(props: IProps) {
  return (
    <Dialog
      open={props.open}
      keepMounted
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={props.handleClose}
      aria-describedby="leave-confirm-dialog"
    >
      <BootstrapDialogTitle id="leave-dialog-title">
        <DialogTitleOptions />
      </BootstrapDialogTitle>
      <DialogContent>
          <DialogContentText id="leave-dialog-description">
          <DialogContentOptions />
          </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancellTextOptions onCancell={props.handleClose} />
        <ConfirmationTextOptions onConfirm={props.handleLeave} />
      </DialogActions>
    </Dialog>
  );
}